module.exports = __webpack_public_path__ + "img/close.6a405289.svg";